import { MainCategoryEnum } from '@insights/insights-data-provider';
const { interaction, nonInteraction, conversion } = MainCategoryEnum;
export const getReporters = ({ getInsightsService, getSceneArticles }) => {
    const report = (eventName, category) => {
        return async (payload) => {
            const sceneArticles = await getSceneArticles();
            const insightsService = await getInsightsService();
            // Default to modified false
            category.modifiedDesign = !!category.modifiedDesign;
            insightsService.reportCustomEventWithSceneArticles({
                event: eventName,
                category,
                payload
            }, sceneArticles);
        };
    };
    return {
        reportAddToCart: async (payload) => (await getInsightsService()).sendAddToCartEvent(payload),
        reportAddToWishlist: async (payload) => (await getInsightsService()).sendAddToWishListEvent(payload),
        reportSaveDesign: async (payload) => (await getInsightsService()).sendSaveDesignEvent(payload),
        reportVpcInteraction: async (payload) => (await getInsightsService()).sendDesignInteractionEvent({
            designId: payload.vpcCode,
            interaction: payload.interaction
        }),
        reportChangeArticle: report('change_article', { mainCategory: interaction, modifiedDesign: true }),
        reportAddArticle: report('add_article', { mainCategory: interaction, modifiedDesign: true }),
        reportDeleteArticle: report('delete_article', { mainCategory: interaction, modifiedDesign: true }),
        reportNavigateMenu: report('navigate_menu', { mainCategory: interaction }),
        reportInteractWithMenu: report('interact_with_menu', {
            mainCategory: interaction
        }),
        reportBookRemotePlanning: report('book_remote_planning', {
            mainCategory: interaction
        }),
        reportSelectTab: report('select_tab', { mainCategory: interaction }),
        reportAddMultiFrameInteriorCombination: report('add_multiframe_interior_combination', { mainCategory: interaction, modifiedDesign: true }),
        reportCopyArticle: report('copy_article', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportToggleRoomSize: report('toggle_room_size', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportCreateNew: report('create_new', { mainCategory: interaction }),
        reportPrint: report('print', { mainCategory: conversion }),
        reportUndo: report('undo', { mainCategory: interaction, modifiedDesign: true }),
        reportRedo: report('redo', { mainCategory: interaction, modifiedDesign: true }),
        reportOpenFilter: report('open_filter', { mainCategory: interaction }),
        reportToggleSorting: report('toggle_sorting', {
            mainCategory: interaction
        }),
        reportSortingApplied: report('sorting_applied', { mainCategory: interaction }),
        reportCloseFilter: report('close_filter', { mainCategory: interaction }),
        reportShareDesignCardStateChange: report('click_share_design_card_state', { mainCategory: interaction }),
        reportCopyDesignCode: report('copy_design_code', { mainCategory: conversion }),
        reportShareViaEmail: report('share_via_email', { mainCategory: conversion }),
        reportShareViaSms: report('share_via_sms', { mainCategory: conversion }),
        reportShareViaClipboard: report('share_via_clipboard', { mainCategory: conversion }),
        reportToggleModal: report('toggle_modal', { mainCategory: interaction }),
        reportSelectImage: report('select_image', { mainCategory: interaction }),
        reportToggleHamburgerMenu: report('toggle_hamburger_menu', { mainCategory: interaction }),
        reportDesignErrorScreen: report('load_design_error_screen', { mainCategory: nonInteraction }),
        reportRemoveAllUnavailableProducts: report('remove_all_unavailable_articles', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportOpenQrCode: report('open_qr_code', {
            mainCategory: nonInteraction
        }),
        reportRenderPrintQrCode: report('render_print_qr_code', {
            mainCategory: nonInteraction
        }),
        reportMoveArticle: report('move_article', { mainCategory: interaction, modifiedDesign: true }),
        reportChangeCornerSolutionOrientation: report('change_corner_frame_orientation', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportOpenProductInformation: report('open_product_information', { mainCategory: interaction }),
        reportOpenProductInformationContextMenu: report('open_product_information_context_menu', { mainCategory: interaction }),
        reportOnSummaryClicked: report('on_summary_clicked', {
            mainCategory: nonInteraction
        }),
        reportGoToSummary: report('go_to_summary', {
            mainCategory: nonInteraction
        }),
        reportSetPostcode: report('set_postcode', { mainCategory: interaction }),
        reportSetStoreLocation: report('set_store_location', { mainCategory: interaction }),
        reportCurrentLocation: report('current_location', { mainCategory: nonInteraction }),
        reportSetNoAvailability: report('set_no_availability', { mainCategory: nonInteraction }),
        reportNavigation: report('navigation', { mainCategory: interaction }),
        reportSelectBlueDot: report('select_blue_dot', { mainCategory: interaction }),
        reportSelectOpeningFunction: report('select_opening_function', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportChangeSolutionFronts: report('change_solution_fronts', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportSelectReadyLayout: report('select_ready_layout', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportLandingPageSelectStart: report('landing_page_select_start', { mainCategory: interaction }),
        reportProppingStatus: report('toggle_propping', {
            mainCategory: interaction
        }),
        reportMeasurementStatus: report('toggle_measurement', {
            mainCategory: interaction
        }),
        reportNightModeStatus: report('toggle_night_mode', {
            mainCategory: interaction
        }),
        reportDoorVisibilityStatus: report('toggle_door_visibility', {
            mainCategory: interaction
        }),
        reportSelectEntity: report('select_item_in_scene', {
            mainCategory: interaction
        }),
        reportFrontsOpeningFunctionSheetChoice: report('fronts_opening_function_choice', { mainCategory: interaction }),
        reportChangePushOpenFunction: report('change_push_open_function', { mainCategory: interaction, modifiedDesign: true }),
        reportDoorPromptReply: report('keep_door_prompt_reply', { mainCategory: interaction }),
        reportSlantedWallSpaceExceededSheet: report('prompt_slanted_wall_space_exceeded', {
            mainCategory: interaction
        }),
        reportSlantedWallShapeSizeChange: report('change_slanted_wall_shape_size', { mainCategory: interaction, modifiedDesign: true }),
        reportRoomSizeChange: report('change_room_size', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportSlantedWallShapeSelected: report('select_slanted_wall_shape', { mainCategory: interaction, modifiedDesign: true }),
        reportTVStatus: report('toggle_tv', { mainCategory: interaction }),
        reportMoveTv: report('move_tv', { mainCategory: interaction, modifiedDesign: true }),
        reportChangeTv: report('change_tv', { mainCategory: interaction, modifiedDesign: true }),
        reportAutoFillLegsToggled: report('toggle_autofill_high_legs', { mainCategory: interaction, modifiedDesign: true }),
        reportAutoFillFrameDepthChange: report('change_autofill_frame_depth', { mainCategory: interaction, modifiedDesign: true }),
        reportAutoFillRecommendationChoice: report('choice_autofill_recommendation', { mainCategory: interaction, modifiedDesign: true }),
        reportAddCustomSlidingDoor: report('add_custom_sliding_door', {
            mainCategory: interaction,
            modifiedDesign: true
        }),
        reportMemoryExceedsThreshold: report('memory_exceeds_threshold', { mainCategory: nonInteraction }),
        reportRotate: report('rotate_frame', { mainCategory: interaction, modifiedDesign: true }),
        reportAccountLogin: report('login_to_account', {
            mainCategory: interaction
        }),
        reportAccountLogout: report('logout_to_account', {
            mainCategory: interaction
        }),
        reportSaveDesignClick: report('click_save_design', {
            mainCategory: interaction
        }),
        reportFinancialServicesMoreInfoClick: report('financial_services_more_info_click', { mainCategory: interaction }),
        reportFinancialServicesContinueButtonClick: report('financial_services_continue_button_click', { mainCategory: interaction }),
        reportSummaryLoaded: report('summary_loaded', { mainCategory: interaction }),
        reportUserLoggedIn: report('user_logged_in', {
            mainCategory: interaction
        }),
        reportAssistanceCardLinkClick: report('click_assistance_card_link', {
            mainCategory: interaction
        }),
        reportSpotlightToggled: report('spotlight_toggle', {
            mainCategory: interaction
        }),
        reportSpotlightAction: report('spotlight_action', { mainCategory: interaction }),
        reportCustomVpcScreenshot: report('custom_vpc_screenshot', { mainCategory: nonInteraction }),
        reportExperimentalRelatedProductsAnalytics: report('experimental_related_products_analytics', {
            mainCategory: nonInteraction
        }),
        reportWebVitals: report('web_vitals', { mainCategory: nonInteraction }),
        reportEnhancedImageRequested: report('enhanced_image_requested', {
            mainCategory: nonInteraction
        }),
        reportEnhancedImageRequestFinished: report('enhanced_image_request_finished', {
            mainCategory: nonInteraction
        }),
        reportCloseModal: report('close_modal', { mainCategory: interaction })
    };
};
//# sourceMappingURL=reporters.js.map